import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

/**
 * Navigating out from modal: [routerLink]="['', { outlets: { primary: 'jobs/job/' + job.id, modal: null } }]"
 */
@Injectable({
  providedIn: 'root',
})
export class MaterialModalService {
  currentDialogRef;

  constructor(public dialog: MatDialog, private router: Router) {}

  open(component) {
    this.currentDialogRef = this.dialog.open(component, {
      width: '100%',
      height: '100%',
      maxWidth: '100vw',
      panelClass: 'mojo-mobile',
    });
  }

  close() {
    this.router.navigate(['', { outlets: { modal: null } }]);
    this.currentDialogRef.close();
  }
}
